import Smartphones from 'Events/Withdrawal/views/WithdrawalCreateView/containers/Smartphones'
import Tablets from 'Events/Withdrawal/views/WithdrawalCreateView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const WithdrawalCreateView = getCurrentDeviceView(Smartphones, Tablets)

export default WithdrawalCreateView
